/**
 * Freemagic signups align with FreeDownloadButton: the tracked event is
 * `Registered for free download` in `utils/tracking/registry.ts`, with a stable
 * Kissmetrics-style `Free download name` per campaign.
 */
export const FREEMAGIC_REGISTERED_FREE_DOWNLOAD_EVENT =
  'Registered for free download' as const

export const FREEMAGIC_TRACKING_SOURCE = 'freemagic' as const

/** Stable "Free download name" values — keep for consistent reporting. */
export const freemagicFreeDownloadNames = {
  cardMagicCourse: 'CardMagicCourse',
  magicInMind: 'MagicInMind',
  sym: 'SYM',
  parlourTricks: 'ParlourTricks',
  ibmAura: 'IBMAura',
} as const
